import { useState, useEffect } from 'react'
import useClient from './useClient'

export default function useContents() {
  const [contents, setContents] = useState(null)
  const {
    client, selectedLocationUUID, app
  } = useClient()

  useEffect(() => {
    if (client && selectedLocationUUID && app) {
      client.contents.getContents(selectedLocationUUID, app).then(res => {
        if(res.success) {
          setContents(res.data)
        }
      })
    }
  }, [client, selectedLocationUUID, app])

  return {
    contents
  }
}
